export const CurrentRouteInfo = (state) => {
  return {
    pathname: state.router.currentRoute.pathname,
    search: state.router.currentRoute.search,
    hash: state.router.currentRoute.hash
  }
}

export const CurrentRouteQueryInfo = (state) => {
  return state.router.currentRouteQuery || {}
}

export const IndexRoutes = (state) => {
  return state.router.indexRoutes
}
